import { SET_DOCUMENTOS_ACE } from "./constants";
import { documentosAce } from "../../../_services/documentos-ace-service";
import { globalCatch } from "../../../_services/global-catch";
import { downloadFile } from "../../../utils";
import { TOKEN_EXPEDIENT } from "../../../constants";

export const setDocumentosAce = (payload) => ({
    type: SET_DOCUMENTOS_ACE,
    payload,
});

export const getAceData = (studentId, academicProgramId) =>
    globalCatch.catch(async (dispatch) => {
        const aceDocuments = await (
            await documentosAce()
        ).getAceData(studentId, academicProgramId);
        const selectedDoc = aceDocuments.data?.documents?.find(doc => aceDocuments.data.selected_document_id === doc.id);
        const mappingDocumentData = {
            data: {
                ...aceDocuments.data,
                documents: selectedDoc ? [selectedDoc] : aceDocuments?.data?.documents
            }

        };
        dispatch(setDocumentosAce(mappingDocumentData));
    });

export const uploadAceData = (studentId, academicProgramId, opts) =>
    globalCatch.catch(async (dispatch) => {
        const aceDocument = await (
            await documentosAce()
        ).storeAceDocument(studentId, academicProgramId, {
            files: opts.file,
            moreInfo: opts.moreInfo || "",
            comments: opts.comments,
            replica: opts.replica,
        });
        dispatch(setDocumentosAce(aceDocument));
    });

export const updateAceData = (documentId, file) =>
    globalCatch.catch(async (dispatch) => {
        const aceDocument = await (
            await documentosAce()
        ).updateAceDocument(documentId, file, {
            moreInfo: null,
            comments: null
        });
        dispatch(setDocumentosAce(aceDocument));
    });

export const downloadAceData = (documentId, fileName) => {
    return downloadFile({
        url: `${micuentaenv.STUDENT_ACCOUNT_API_basePath}/account/document/${documentId}/download`,
        fileName: fileName,
        TOKEN: TOKEN_EXPEDIENT,
    });
};
